// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Menu-Menu-module__MenuButton";
var _2 = "webpack-components-core-Menu-Menu-module__MenuItem";
var _3 = "webpack-components-core-Menu-Menu-module__MenuItemBox";
var _4 = "webpack-components-core-Menu-Menu-module__MenuList";
var _5 = "webpack-components-core-Menu-Menu-module__MenuPopover";
var _6 = "webpack-components-core-Menu-Menu-module__MenuSeparator";
var _7 = "webpack-components-core-Menu-Menu-module__MenuTrigger";
export { _1 as "MenuButton", _2 as "MenuItem", _3 as "MenuItemBox", _4 as "MenuList", _5 as "MenuPopover", _6 as "MenuSeparator", _7 as "MenuTrigger" }
